import React, { useState, useEffect } from 'react';

import { Grid, Typography, CircularProgress } from '@mui/material';
import { isEmpty } from 'lodash';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import theme from '../theme';
import { ThemeProvider } from '@mui/material/styles';
import { Colors } from '../config/default';
import Btn from '../components/button';
import {
  searchDeliveryTicketbyVendorName,
  attachDeliveryTicket,
  getDocumentDetails,
  deleteDeliveryTicket,
  getAttachmentsbyDocId
} from '../services/services';
import { useToast } from '../toast/toastContext';
import ImageSelect from './dtImageSelect';
import SearchBar from './searchBar';
import Prompt from './prompt';
import Navigation from './navigation';
import { formatDateOnly } from '../services/common';
import { attachDeliveryTicketPage } from '../constants/appConstants';

function AttachDeliveryTicket({
  setImages,
  setImagesPreview,
  setOpen,
  setRefId,
  vendor,
  po,
  invoiceNumber,
  jobId,
  vendorNumber,
  date,
  refId,
  setIndex
}) {
  const {
    DELIVERY_TICKET,
    ATTACH_DELIVERY_TICKET,
    NO_DT,
    NO_DT_FOUND,
    NO_SUGGESTED_DT,
    DT_SUGGESTION_CRITERIA,
    SUGGESTED_DELIVERY_TICKET,
    SHOW_ALL_DT,
    ALL_DELIVERY_TICKETS
  } = attachDeliveryTicketPage;
  const { id } = useParams();
  const { showToast } = useToast();
  const [foundDocument, setFoundDocument] = useState([]);
  const [allDocument, setAllDocument] = useState([]);
  const [searching, setSearching] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [searchDocumnet, setSearchDocuments] = useState('');
  const [searchedResult, setSearchedResult] = useState([]);
  const [isDocumentSearched, setIsDocumentSearched] = useState(false);
  const [deleteDocumentId, setDeleteDocumentId] = useState([]);
  const [attachDocs, setAttachDocs] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [openPrompt, setOpenPrompt] = useState(false);
  const [navigationValue, setNavigationValue] = useState(0);
  const userDetails = useSelector((state) => state?.userInfo?.userInfo);
  const companyId = userDetails?.company?._id;

  const serachDT = async (showAllDT) => {
    setSearching(true);
    const response = await searchDeliveryTicketbyVendorName(
      vendor,
      formatDateOnly(date),
      po ? po : 'N/A',
      invoiceNumber,
      showAllDT,
      {jobId, vendorNumber}
    );
    if (response?.status === 200) {
      if (!showAllDT) {
        setAllDocument(response?.data?.payload?.data);
        setShowAll(true);
      } else {
        setFoundDocument(response?.data?.payload?.data);
      }
    }
    setSearching(false);
  };
  const getAttachedDT = async () => {
    setIsLoading(true);
    const response = await getAttachmentsbyDocId(id);
    if (response?.status === 200) {
      setAttachDocs(response?.data?.payload?.data);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    serachDT(true);
    getAttachedDT();
  }, []);

  const handleAttachFile = async () => {
    setLoading(true);
    const params = {
      hostDocumentId: id,
      referenceDocument: selectedDocumentId,
      companyId: companyId
    };
    const result = await attachDeliveryTicket(params);
    if (result?.status === 200) {
      const res = await getDocumentDetails(id, 'app');
      if (res?.status === 200) {
        setImages(res?.data?.payload?.data?.document?.convertedS3Keys);
        setImagesPreview(res?.data?.payload?.data?.document?.convertedS3KeysPreview);
        setRefId(res?.data?.payload?.data?.document?.documentReference);
      }
      showToast(result?.data?.metadata?.message, 'success');
      setOpen(false);
    } else {
      showToast(
        result?.response?.data?.metadata?.message || result?.data?.metadata?.message,
        'error'
      );
    }

    setLoading(false);
  };
  const handleClearSearch = () => {
    setIsDocumentSearched(false);
    setSearchDocuments('');
    setSearchedResult([]);
  };

  const handleSearchDocument = () => {
    if (!searchDocumnet) return;
    setSearching(true);
    let filteredResults;
    if (!isEmpty(allDocument)) {
      filteredResults = allDocument?.filter((doc) =>
        doc?.standardizeContent?.document_number?.includes(searchDocumnet)
      );
    } else {
      filteredResults = foundDocument?.filter((doc) =>
        doc?.standardizeContent?.document_number?.includes(searchDocumnet)
      );
    }
    if (!isEmpty(filteredResults)) {
      setSearchedResult(filteredResults);
      setIsDocumentSearched(true);
    } else {
      setSearchedResult([]);
      setIsDocumentSearched(true);
    }

    setSearching(false);
  };
  const handleOpen = () => {
    setOpenPrompt(true);
  };
  const handleDeleteAttachment = async () => {
    setDeleting(true);
    const params = {
      hostDocumentId: id,
      referenceDocument: deleteDocumentId,
      companyId: companyId
    };
    const result = await deleteDeliveryTicket(params);
    if (result?.status === 200) {
      const res = await getDocumentDetails(id, 'app');
      if (res?.status === 200) {
        setImages(res?.data?.payload?.data?.document?.convertedS3Keys);
        setImagesPreview(res?.data?.payload?.data?.document?.convertedS3KeysPreview);
        setRefId(res?.data?.payload?.data?.document?.documentReference);
      }
      setIndex(0);
      showToast(result?.data?.metadata?.message, 'success');
      setOpenPrompt(false);
      setOpen(false);
    } else {
      showToast(
        result?.response?.data?.metadata?.message || result?.data?.metadata?.message,
        'error'
      );
    }
    setDeleting(false);
  };
  return (
    <ThemeProvider theme={theme}>
      <Grid container item xs={12} sx={{ padding: '.5rem' }}>
        <Typography variant="h6" sx={{ color: Colors.WHITE }}>
          {DELIVERY_TICKET}
        </Typography>

        <Grid
          item
          xs={12}
          sx={{
            height: '59vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            overflowY: 'auto',
            display: 'flex',
            margin: '1rem 0'
          }}>
          <Grid
            container
            sx={{
              justifyContent: navigationValue === 0 ? 'space-between' : 'flex-end',
              height: 'max-content'
            }}>
            {navigationValue === 0 && (
              <SearchBar
                width="350px"
                setSearchProducts={setSearchDocuments}
                text="Search Delivery Ticket..."
                searchProducts={searchDocumnet}
                tooltipText="Search by Document No"
                handleKeyPress={handleSearchDocument}
                handleClear={handleClearSearch}
                recordExist={isDocumentSearched}
                filteredData={searchedResult}
              />
            )}
            <Navigation
              value={navigationValue}
              setValue={setNavigationValue}
              label1="Attach"
              label2="Remove"
            />
          </Grid>
          {navigationValue === 1 ? (
            <>
              {!isEmpty(refId) && !isEmpty(attachDocs) ? (
                <>
                  <Typography sx={{ color: Colors.TOURQUISE, marginTop: '1rem' }}>
                    {ATTACH_DELIVERY_TICKET}
                  </Typography>
                  <Grid container spacing={1} sx={{ padding: '1rem .5rem .5rem 0rem' }}>
                    {attachDocs?.map((data) => {
                      return (
                        <ImageSelect
                          data={data}
                          btnText=""
                          selectedDocumentId={deleteDocumentId}
                          setSelectedDocumentId={setDeleteDocumentId}
                          variant="caption"
                          fontLength={9}
                          url={data?.convertedS3Keys[0]}
                        />
                      );
                    })}
                  </Grid>
                </>
              ) : (
                <Grid
                  container
                  sx={{ height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                  <p style={{ color: Colors.TEXTGREY }}>{NO_DT}</p>
                </Grid>
              )}
            </>
          ) : (
            <>
              {searching || isloading ? (
                <Grid
                  container
                  sx={{ alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                  <CircularProgress size={60} color="primary" />
                </Grid>
              ) : isEmpty(foundDocument) && isEmpty(refId) && isEmpty(allDocument) && showAll ? (
                <Grid
                  container
                  sx={{ height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                  <p style={{ color: Colors.TEXTGREY }}> {NO_DT_FOUND}</p>
                </Grid>
              ) : isEmpty(foundDocument) && isEmpty(allDocument) ? (
                <Grid
                  container
                  sx={{
                    height: '50%',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    flexDirection: 'column'
                  }}>
                  <Typography style={{ color: Colors.TEXTGREY }}>{NO_SUGGESTED_DT}</Typography>
                  <Typography
                    style={{
                      color: Colors.WHITE,
                      fontSize: '.7rem'
                    }}>
                    {DT_SUGGESTION_CRITERIA}
                  </Typography>
                </Grid>
              ) : isDocumentSearched ? (
                <>
                  {!isEmpty(searchedResult) ? (
                    <Grid container spacing={1} sx={{ padding: '1rem .5rem .5rem 0rem' }}>
                      {searchedResult?.map((data) => {
                        return (
                          <ImageSelect
                            data={data}
                            btnText=""
                            selectedDocumentId={selectedDocumentId}
                            setSelectedDocumentId={setSelectedDocumentId}
                            variant="caption"
                            fontLength={9}
                            url={data?.convertedS3Keys[0]}
                          />
                        );
                      })}
                    </Grid>
                  ) : (
                    <Grid
                      container
                      sx={{ height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                      <p style={{ color: Colors.TEXTGREY }}>{NO_DT_FOUND}</p>
                    </Grid>
                  )}
                </>
              ) : (
                <>
                  {!isEmpty(foundDocument) && (
                    <>
                      <Typography sx={{ color: Colors.TOURQUISE, mt: '1rem' }}>
                        {SUGGESTED_DELIVERY_TICKET}
                      </Typography>
                      <Typography sx={{ color: Colors.WHITE, fontSize: '.7rem' }}>
                        {DT_SUGGESTION_CRITERIA}
                      </Typography>
                    </>
                  )}

                  <Grid container spacing={1} sx={{ padding: '1rem .5rem .5rem 0rem' }}>
                    {foundDocument?.map((data) => {
                      return (
                        <ImageSelect
                          data={data}
                          btnText=""
                          selectedDocumentId={selectedDocumentId}
                          setSelectedDocumentId={setSelectedDocumentId}
                          variant="caption"
                          fontLength={9}
                          url={data?.convertedS3Keys[0]}
                        />
                      );
                    })}
                  </Grid>
                </>
              )}
              <>
                {!showAll && !isDocumentSearched && !searching && !isloading && (
                  <Grid
                    container
                    sx={{
                      justifyContent: 'center',
                      marginTop: '.5rem'
                    }}>
                    <Typography
                      variant="caption"
                      sx={{ color: Colors.TOURQUISE, cursor: 'pointer' }}
                      onClick={() => serachDT(false)}>
                      {SHOW_ALL_DT}
                    </Typography>
                  </Grid>
                )}
                {showAll && !isEmpty(allDocument) && !isDocumentSearched && (
                  <>
                    <Typography sx={{ color: Colors.TOURQUISE, marginTop: '.5rem' }}>
                      {ALL_DELIVERY_TICKETS}
                    </Typography>
                    <Grid container spacing={1} sx={{ padding: '1rem .5rem .5rem 0rem' }}>
                      {allDocument?.map((data) => {
                        return (
                          <ImageSelect
                            data={data}
                            btnText=""
                            selectedDocumentId={selectedDocumentId}
                            setSelectedDocumentId={setSelectedDocumentId}
                            variant="caption"
                            fontLength={9}
                            url={data?.convertedS3Keys[0]}
                          />
                        );
                      })}
                    </Grid>
                  </>
                )}
              </>
            </>
          )}
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          {navigationValue === 1 && (
            <>
              <Prompt
                title="Delete Delivery Tickets"
                description="Are you sure you want to proceed?"
                leftButton="Cancel"
                rightButton="Delete"
                setOpen={setOpenPrompt}
                open={openPrompt}
                opacity={false}
                handleClick={handleDeleteAttachment}
                loading={deleting}
              />
              <Btn
                width={{ xs: '9rem', xl: '100%' }}
                disabled={isEmpty(deleteDocumentId)}
                text="Remove"
                backgroundColor={Colors.RED}
                height="2.2rem"
                radius="10px"
                color={Colors.WHITE}
                onClick={handleOpen}
                disabledColor={Colors.NAV_BLACK}
              />
            </>
          )}
          {navigationValue === 0 && (
            <Btn
              width={{ xs: '9rem', xl: '100%' }}
              loading={loading}
              disabled={isEmpty(selectedDocumentId)}
              text="Attach"
              backgroundColor={Colors.DEEPBLUE}
              height="2.2rem"
              radius="10px"
              color={Colors.WHITE}
              onClick={handleAttachFile}
              disabledColor={Colors.NAV_BLACK}
            />
          )}
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default AttachDeliveryTicket;
